import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import { OcrConfiguration } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

export const loadOcrConfigurations = async (
    environmentId: string,
    tenantId: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[OcrConfiguration | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.get(
        `environments/${environmentId}/tenants/${tenantId}/features/ocr/configurations`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const updateOcrConfigurations = async (
    environmentId: string,
    tenantId: string,
    config: OcrConfiguration
): Promise<[string | null, number]> => {
    if (!environmentId || !tenantId) {
        return defaultErrorResponse;
    }

    const response = await API.put(
        `environments/${environmentId}/tenants/${tenantId}/features/ocr/configurations`,
        config
    );

    return [response.data, response.status];
};
